export const campsVisitedTranslations = {
    en: {
        // Drawer Title
        viewHealthCampActivities: "View Health Camp Activities",

        // Tooltips
        campDate: "Camp Date",

        // Buttons
        viewCampDetails: "View Camp Details",
        campActivities: "Camp Activities",

        // Messages
        unknown: "Unknown",
        camps: "Camps"
    },
    mr: {
        // Drawer Title
        viewHealthCampActivities: "आरोग्य शिबिर क्रियाकलाप पहा",

        // Tooltips
        campDate: "शिबिर तारीख",

        // Buttons
        viewCampDetails: "शिबिर तपशील पहा",
        campActivities: "शिबिर क्रियाकलाप",

        // Messages
        unknown: "अज्ञात",
        camps: "शिबिरे"
    }
};
